import * as React from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import {
  RackRive,
  LaunchablesRive,
  type RackRiveInputs,
  type LaunchablesRiveInputs,
} from "./index";

interface ProductCardProps {
  title: string;
  description: string;
  variant: "gpu" | "launchables";
  href?: string;
}

export function ProductCard({
  title,
  description,
  variant,
  href,
}: ProductCardProps) {
  const [riveInputs, setRiveInputs] = useState<
    RackRiveInputs | LaunchablesRiveInputs | null
  >(null);

  const handleMouseEnter = () => {
    const boolInput = riveInputs?.getInput("isHover");
    if (boolInput) boolInput.value = true;
  };

  const handleMouseLeave = () => {
    const boolInput = riveInputs?.getInput("isHover");
    if (boolInput) boolInput.value = false;
  };

  const content = (
    <div
      className="flex h-full flex-col border-r border-l border-zinc-800"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div className="mb-4 flex w-full flex-col items-center">
        <h3 className="text-2xl font-bold">{title}</h3>
        <p className="text-muted-foreground px-4 py-2">{description}</p>
      </div>
      {variant === "gpu" ? (
        <RackRive scale={1} className="h-full w-full" onLoad={setRiveInputs} />
      ) : (
        <LaunchablesRive
          scale={1}
          className="h-full w-full"
          onLoad={setRiveInputs}
        />
      )}
    </div>
  );

  if (!href) {
    return content;
  }

  return (
    <Link
      to={href}
      className="group block h-full focus:outline-none focus:ring-2 focus:ring-highlight"
    >
      {content}
    </Link>
  );
}
